<template>
	<div grey-back full-height>

		<v-toolbar flat fixed>
		    <v-toolbar-side-icon @click="fn_goBack"><v-icon>arrow_back</v-icon></v-toolbar-side-icon>
		    <v-toolbar-title class="white--text">Add Godown</v-toolbar-title>
		</v-toolbar>

		<v-form class="form-element hasToolbar hasFooter grey-back">

			<v-layout wrap padding-top-bottom-ten white-background>
					<v-flex xs12 sm12 md12 form-item>
		               <v-text-field 
                            v-model="Form.name" 
                            label="Name" 
                            placeholder=" " 
                            v-validate="'required|max:50'" 
                            :error-messages="errors.collect('name')" 
                            data-vv-name="name" 
                            required>
                        </v-text-field>
		            </v-flex>

                    <v-flex xs12 sm12 md12 form-item>
		               <v-textarea 
                            rows="2"
                            v-model="Form.address" 
                            label="Address" 
                            placeholder=" ">
                        </v-textarea>
		            </v-flex>

                    <v-flex xs12 sm12 md12 form-item padding-top-ten @click="fn_openStateDialog('android', 'state', 'ref_fieldState')">
                        <v-text-field  
                            readonly
                            :onUpdate="fn_updateState"
                            ref="ref_fieldState"
                            v-model="Form.state" 
                            label="State" 
                            placeholder=" " 
                            append-icon="arrow_drop_down"
                            v-validate="'required'"
                            data-vv-name="state" 
                            data-vv-as="state" 
                            :error-messages="errors.collect('state')"
                            required>
                        </v-text-field>
                    </v-flex>
				
			</v-layout>

			<div style="position:fixed;bottom:0" full-width>
				<v-btn noroundborders color="primary" block nomargin class="height48" @click="fn_checkValidations" style="border-radius:0;">Save</v-btn>
			</div>
		</v-form>

	    <v-dialog v-model="loading" no-click-animation persistent max-width="290">
	      <v-card>
	        <v-card-text class="align_vertical_middle">
	          <v-progress-circular indeterminate color="primary"></v-progress-circular> Please wait...
	        </v-card-text>
	      </v-card>
	    </v-dialog>

	    <!-- fn_draftAction is in draft mixin -->
	    <dialog-discard ref="ref_dialogDiscard" :draftAction="fn_draftAction" :save="fn_checkValidations" :hideKeepDraft="true"></dialog-discard>

	    <!-- <dialog-draft-items ref="ref_dialogDraftItems" :draftItems="Form.draftItems" :importDraft="fn_importDraft" :removeDraftItem="fn_removeDraftItem"></dialog-draft-items> -->

	    <v-snackbar v-model="snackbar" :timeout="2000">{{snackbar_msg}}</v-snackbar>

	</div>
</template>

<script>
const dialogjs =  require('../dialog').dialogjs;
const menuItem = require('../../../../config.js').configs.menuItem;

import dialogDiscard from '../../../dialogs/dialog_discard'
import {draftMixin} from '../../../draft_mixin'
// import dialogDraftItems from '../../../dialogs/dialog_draft_items'

	export default{
		mixins: [draftMixin],
		data(){
			return{
            Form:{"godownId":null, "name":null, "address":null, "stateId":null, "state":null, "additionalData":{}, 'godownType':null},
				loading:false,
				tagId:null,
				draftStorageId:null,
				snackbar:false,
				snackbar_msg:null,
				backButtonPress:false,
			}
		},
		watch:{
			'Form': {
                handler: function (newVal, oldVal){
                    if(!this.unwatch){
                     	this.fn_saveDraft(this.Form.name);
                    }
                    this.unwatch = false;
                 },
                deep: true
            }
		},
		components:{
			'dialog-discard': dialogDiscard,
		},
		methods:{

			fn_openDialogDiscard: function(){
				this.fn_openDialogWeb('web', 'Discard', 'ref_dialogDiscard')
			},

			fn_openDialogWeb: function (platform, name, ref) {

				let scroll_y = window.scrollY;
				this.fn_fixBackgroundScroll();

				var tagId = this.guidWeb();

				var dialogObj = {};
				dialogObj.tagId = tagId;
				dialogObj.formId = this.formId;
				dialogObj.name = name;
				dialogObj.ref = ref;
				dialogObj.data = null;
				dialogObj.platform = platform;

				dialogObj.scrollPosition = {};
				dialogObj.scrollPosition.x = 0;
				dialogObj.scrollPosition.y = scroll_y;

				dialogjs.fn_pushDialogInStack(this.dialogStorageId, dialogObj, this);

				this.$refs[ref].openDialogWeb();
			},

			fn_closeDialog: function (tagId) {
				dialogjs.fn_checkAndCloseOpenDialogs(this);
			},

			// fn_getBottomMenu: function (tagId) {
			// 	var bottomMenu = {"BottomMenu": [menuItem.save, menuItem.reset, menuItem.help]};
			// 	this.setBottomMenu(tagId, bottomMenu, 
			// 		{
			// 			onSuccess: function (response) {
			// 				console.log(response);
			// 			},
			// 			onError: function (error) {
			// 				console.log(error);
			// 			}
			// 		}
			// 	)
			// },

			fn_checkValidations: function(){
				var self = this;
			    this.$validator.validateAll().then((result) => {
			        if (result) {
			           self.fn_post();
			          	return; 
			        }
			        // else{
			        // 	this.$vuetify.goTo('.error--text', this.scrollOptions);
			        // }
			        self.loading = false;
			    });
			},

			fn_saveLocal: function(dataObj){
				var self = this;
				this.postData('PostGodown', dataObj, 
					{
						onSuccess: function(response){
				          console.log(response);
				        //   let status = JSON.parse(response);
                          self.fn_cleanUp();
				        //   if(status) {
				        //   	self.fn_cleanUp();
				        //   }
				        //   else {
				        //   	self.showToast("Already exists with this name");
				        //   }
				        },
				        onError: function(error){
				          console.log(error);
				        }
					}
		        );
		        // this.fn_goBack();
			},

			fn_cleanUp: function () {

				// this.loadedFromDraft = false;

				if(this.$route.query.ls){
					let data = {};
					data.type = this.$route.query.type ? this.$route.query.type : 'godown';
					data.id = this.Form.godownId;
					data.name = this.Form.name;
					localStorage.setItem('newItem', JSON.stringify(data));
					localStorage.setItem('closeDialog', 1);
				}

				let self = this;
				this.fn_removeDraft(this.draftStorageId, function(){

					if(localStorage.getItem("master_items_state")){
						let obj = JSON.parse(localStorage.getItem("master_items_state"));
						obj.itemId = self.Form.godownId;
						localStorage.setItem("master_items_state",JSON.stringify(obj));
					}

					self.$router.go(-1);
				});
			},

			fn_post: function(){	
                if(!this.Form.godownId){
					this.Form.godownId = this.guid();
					this.Form.createdDate = this.$root.fn_getLocalDateFormat();
				}

				// this.Form.modifiedDate = new Date();
				this.Form.modifiedDate = this.$root.fn_getLocalDateFormat();

				this.Form.name = this.Form.name.trim();
				console.log(this.Form);
				this.fn_saveLocal(this.Form);
			},

			fn_get: function(itemId, copyData){
				var self = this;
				this.getData('GetGodown', itemId, 
					{
						onSuccess: function(response){
				            console.log(self.Form);
				            self.unwatch = true;
				            self.Form = JSON.parse(response);
					        self.$root.fn_copyFormObject(self.Form, self.formId);
				        }, 
				        onError: function(error){
				          console.log(error);
				        }
					}
		        );
			},

			fn_menuItemClick: function(tagId, menuId, menuAction){
				// tagId id form future use
				// menuId id form future use

				this.backButtonPress = false;
				
				if(menuAction=='save'){
					this.fn_checkValidations();
				}
				else if(menuAction=='reset'){
					this.fn_resetForm();
				}
			},

			fn_showWebView: function () {
				var viewObject = {};
				viewObject.ToolbarTitle = "Godown";
				viewObject.TopMenu = [menuItem.save];
				viewObject.isBottomMenu = true;
				// viewObject.BottomMenu = [{"MenuID":2, "MenuType":null, "Icon":"save", "Text":"Save", "Action": "save"}]
				var tagId = this.formId;
				var self = this;
				this.showWebView(tagId, viewObject, 
					{
						onSuccess: function(response){
				          console.log(response);
				        }, 
				        onError: function(error){
				          console.log(error);
				        }, 
				        // onChange: null,
				        onMenuItemClick: function (tagId, menuId, menuAction) {
							self.fn_menuItemClick(tagId, menuId, menuAction)
						}
					}
				);
			},

			// fn_setFormDataFromLocalStorage: function () {
			// 	if(localStorage.getItem(this.draftStorageId)){
			// 		var formData = JSON.parse(localStorage.getItem(this.draftStorageId));
			// 		this.Form = formData.dataModel;
					
			// 		if((this.$route.query && this.$route.query.draft) || (this.$route.params && this.$route.params.tagId)){
			// 			this.loadedFromDraft = true;
			// 		}
			// 	} 
			// },

            fn_openStateDialog: function (platform, name, ref) {

				var tagId = this.guidWeb();

				var dialogObj = {};
				dialogObj.tagId = tagId;
				dialogObj.formId = this.formId;
				dialogObj.name = name;
				dialogObj.ref = ref;
				//dialogObj.data = null;
				dialogObj.platform = platform;

				var viewDialogObject = {};
				viewDialogObject.ToolbarTitle = "Select State";
				viewDialogObject.TopMenu = [menuItem.new];
				viewDialogObject.isBottomMenu = false;

				var paramObject = {};
				paramObject.defaultValue = {"id":null, "name":null};

				if(this.Form.stateId && this.Form.state){
                    paramObject.defaultValue = {"id":this.Form.stateId, "name":this.Form.state};
                }

				dialogjs.fn_openDialog(this, dialogObj, viewDialogObject, 'state', tagId, paramObject, ref);
			},

            fn_onChange: function(tagId, ref, selectedValueId, selectedValueName, isRemoved){
				this.$refs[ref].$attrs.onUpdate(selectedValueId, selectedValueName, isRemoved);
			},

            fn_updateState: function (selectedValueId, selectedValueName, isRemoved) {
				if(!isRemoved){
					this.Form.stateId = selectedValueId;
		        	this.Form.state = selectedValueName;
				}
				else{
					this.Form.stateId = null;
		        	this.Form.state = null;
				}
			},

			fn_goBack: function(){
				this.backButtonPress = true;
				this.$router.go(-1);
			}
		},
		mounted: function(){
			var self = this;

			if(this.$route.query && this.$route.query.tagId){//in case of new form
				this.formId = this.$route.query.tagId;
				this.draftStorageId = 'draft_master_'+this.formId;
				this.dialogStorageId = 'dialog_'+this.formId;
			}
			else if(this.$route.params && this.$route.params.tagId){//in case of edit form
				this.formId = this.$route.params.tagId;
				this.draftStorageId = 'draft_master_'+this.formId;
				this.dialogStorageId = 'dialog_'+this.formId;
			}

			// var formsArray = [];
			// if(localStorage.getItem('listsforms')){
			// 	formsArray = JSON.parse(localStorage.getItem('listsforms'));
			// }

			// formsArray.push(this.formId);
			// localStorage.setItem('listsforms', JSON.stringify(formsArray));

			window.js_globals.fn_onBackPress = this.fn_goBack;
			window.js_globals.fn_getBottomMenu = this.fn_getBottomMenu;
			window.js_globals.fn_closeClick = this.fn_closeDialog;

			this.fn_showWebView();

	       if((this.$route.query && this.$route.query.tagId) || (this.$route.params && this.$route.params.tagId)){
				// this.fn_setFormDataFromLocalStorage();
				this.fn_setFormDataFromDraft(function(draft){

					if(draft){
						self.Form = JSON.parse(draft.formData);

			            // if((self.$route.query && self.$route.query.draft) || (self.$route.params && self.$route.params.tagId)){
			            //   self.loadedFromDraft = true;
			            // }
					}

					// self.$route.query.tagId ? self.fn_checkDraftItems('List', true) : '';

				});
			}

			let formElement = document.getElementsByClassName("form-element")[0];

			formElement.addEventListener("submit", function(e){
			    e.preventDefault();
			});

			// this.fn_setDraftData('Master', 'List');
			this.fn_setDraftData('temp', 'List');
		},
		beforeRouteEnter (to, from, next) {
		  	next(vm => {
		  		vm.enableToolbar();
		  		
		  		let itemId = null;
		  		let copyData = false;

		  		//edit from display view 
		  		if((from.params && from.params.tagId) && (to.query && !to.query.tagId)){
					itemId = from.params.tagId;  			
		  		}

		  		//edit from list view
		  		else if((from.name=='listsItems' || from.name=='listsItemItems') && (to.params && to.params.tagId)){
		  			itemId = to.params.tagId;
		  		}

		  		//copy data
		  		if(to.query && to.query.copy){
		  			if(from.name == 'listsItems' || from.name=='listsItemItems'){ //copy from list view
		  				itemId = to.query.itemId;
		  			}
		  			copyData = true;
		  		}
		  		
		  		
		  		//checking if draft exist
		  		// vm.fn_isDraft(function(isDraft){
		  		// 	if(itemId && !isDraft){
		  		// 		vm.fn_get(itemId, copyData);
		  		// 	}
		  		// })

		  		if(itemId){
	  				vm.fn_get(itemId, copyData);
	  			}
	  			else{
					vm.$root.fn_copyFormObject(vm.Form, vm.formId)	  				
	  			}

		  		// if(itemId && !localStorage.getItem(vm.draftStorageId)){
		  		// 	vm.fn_get(itemId, copyData)
		  		// }
		  	})
		},
		beforeRouteLeave (to, from, next) {
			var dialogData = JSON.parse(localStorage.getItem(this.dialogStorageId));
			if(dialogData && dialogData.length){

				if(this.backButtonPress){
					dialogjs.fn_checkAndCloseOpenDialogs(this);
					next(false);
				}
				else{
					// this.$root.fn_deleteFormObject();
					this.fn_saveDraft(this.Form.name);
					next(true);
				}
			}
			else{
				// if(this.askToDiscard){
				// 	this.fn_openDialogDiscard();
				// 	next(false);
				// }
				if(this.fn_showDialogDiscard()){
					this.fn_openDialogDiscard();
					next(false);
				}
				else{
					this.fn_clearData(null, function(){
						next();
					})
				}
				// if(this.loadedFromDraft || (this.$root.fn_getFormObject(this.formId) && !this.$root.fn_deepEqual(this.Form, JSON.parse(this.$root.fn_getFormObject(this.formId))))){
				// 	this.fn_openDialogDiscard();
				// 	next(false);
				// }
				// else{
				// 	this.$root.fn_deleteFormObject(this.formId);
				// 	!this.askToDiscard ? this.fn_removeDraft(this.draftStorageId, null, -1) : '';
				// 	next();	
				// }
				
			}
	    }
	}

</script>


// WEBPACK FOOTER //
// src/components/masters/forms/godowns/form.vue